export const trainingsSelector = (state: any) => state.trainings;
